import { render, staticRenderFns } from "./ModalListaEscala.vue?vue&type=template&id=15d398f1"
import script from "./ModalListaEscala.vue?vue&type=script&lang=js"
export * from "./ModalListaEscala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports